import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=04221d72&scoped=true&"
import script from "@/scripts/QA/Question/components/Feedback/Feedback?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/Feedback/Feedback?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04221d72",
  null
  
)

export default component.exports